
export function setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + ((expDays ?? 3) * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    // json encode the value
    cValue = Array.isArray(cValue) ? cValue : [cValue];
    cValue = getUniqueValuesAsJson(cValue);
    document.cookie = cName + "=" + encodeURIComponent(cValue + "; " + expires + "; path=/");
}

export function deleteCookies() {
    let theCookies = document.cookie.split(';');
    for (let i = 0; i < theCookies.length; i++) {
        document.cookie = theCookies[i].split('=')[0] + '=; path=/manage; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = theCookies[i].split('=')[0] + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}

export function getCookie(cName) {
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie);
    const cArr = cDecoded.split('; ');
    let value;
    cArr.forEach(val => {
        if (val.indexOf(name) === 0) value = val.substring(name.length);
    });

    return decodeCookieValue(value);
}

export function getUniqueValuesAsJson(values) {
    const uniqueValues = [...new Set(values)];
    return JSON.stringify(uniqueValues);
}

export function decodeCookieValue(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        // if not valid JSON, just return the string
        return str;
    }
}
